<template>
   <label :for="fieldData.name" 
      class="classLabel col-12 px-0 pt-1">{{ fieldData.label }}</label>
   <Field :name="fieldData.name" 
      class="form-control col-12 py-0 px-1" 
      v-slot="{ field }"
      >
      <textarea v-bind="field" 
         class="form-control col-12 p-0 px-1"
         :tabindex="tabindex"
         type="textarea" 
         :rows="1" 
         :id="id"
         />
   </Field>
   <div class="col-12 text-end fst-italic fs-14">
      <ErrorMessage :name="fieldData.name" 
         class="error-feedback" />
   </div>
</template>

<script>
import { Field, ErrorMessage } from "vee-validate";

export default {
   name: 'TextareaField',
   components: {
      Field,
      ErrorMessage,
   },
   props: {
      fieldData: {
         type: Object,
         required: true,
      },
      id: { 
         type: String,
         default: 'text'
      },
      tabindex: { type: Number }
   },
   /*
   setup() {
      return {
      :rules="fieldData.rules" 

      :tabindex="fieldData.tabindex"
      :id="fieldData.name"
      }
   }
   */
}
</script>

<style>
.fs-14 {
   font-size: 14px;
}
</style>